import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CurriculumInterface } from '../../+models';
import { CurriculumsActions, CurriculumsActionTypes } from './curriculum.actions';

export const NAME = 'curriculums';

export interface State extends EntityState<CurriculumInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<CurriculumInterface> = createEntityAdapter<CurriculumInterface>({
  selectId: (curriculum: CurriculumInterface) => curriculum.guid,
});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: CurriculumsActions): State {
  switch (action.type) {
    case CurriculumsActionTypes.AddCurriculum: {
      return adapter.addOne(action.payload.curriculum, state);
    }

    case CurriculumsActionTypes.UpsertCurriculum: {
      return adapter.upsertOne(action.payload.curriculum, state);
    }

    case CurriculumsActionTypes.AddCurriculums: {
      return adapter.addMany(action.payload.curriculums, state);
    }

    case CurriculumsActionTypes.UpsertCurriculums: {
      return adapter.upsertMany(action.payload.curriculums, state);
    }

    case CurriculumsActionTypes.UpdateCurriculum: {
      return adapter.updateOne(action.payload.curriculum, state);
    }

    case CurriculumsActionTypes.UpdateCurriculums: {
      return adapter.updateMany(action.payload.curriculums, state);
    }

    case CurriculumsActionTypes.DeleteCurriculum: {
      return adapter.removeOne(action.payload.id, state);
    }

    case CurriculumsActionTypes.DeleteCurriculums: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case CurriculumsActionTypes.CurriculumsLoaded: {
      return adapter.setAll(action.payload.curriculums, {
        ...state,
        loaded: true,
      });
    }

    case CurriculumsActionTypes.CurriculumsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case CurriculumsActionTypes.ClearCurriculums: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
